<template>
  <div class="flex flex-row border-t border-gray-200 px-4 py-4 sm:px-6 justify-center">
    <div
      v-if="currentScreen !== totalScreens"
      class="flex flex-col w-full justify-center"
    >
      <div class="w-full sm:w-1/3 md:w-1/2 mx-auto">
        <div class="flex flex-row justify-center mb-5 -mx-2">
          <div class="inline-flex px-2 w-1/2">
            <button
              type="button"
              class="w-full px-4 py-2 border border-transparent text-base leading-6
              font-medium rounded-md text-white bg-green-500 hover:bg-green-400
              focus:outline-none focus:border-green-700 focus:shadow-outline-green
              active:bg-green-700 transition ease-in-out duration-150 shadow-sm"
              :class="{'opacity-50': disableNext}"
              :disabled="disableNext"
              @click="$emit('nextScreen')"
            >
              Next &#45;&#62;
            </button>
          </div>
        </div>
      </div>
      <button
        class="text-gray-500 text-sm text-center underline focus:outline-none"
        @click="$emit('skip')"
      >
        Skip to see all quotes
      </button>
    </div>

    <button
      v-if="currentScreen === totalScreens"
      type="button"
      class="w-full sm:w-1/2 px-4 py-2 border border-transparent text-base leading-6
            font-medium rounded-md text-white bg-green-500 hover:bg-green-400
            focus:outline-none focus:border-green-700 focus:shadow-outline-green
            active:bg-green-700 transition ease-in-out duration-150 text-center"
      :class="{'opacity-50': nextDisabled}"
      :disabled="nextDisabled"
      @click="$emit('finish')"
    >
      Take me to my results
    </button>
  </div>
</template>

<script>
export default {
  name: 'OnboardingFooter',
  props: {
    currentScreen: {
      type: Number,
      default: () => 1,
    },
    totalScreens: {
      type: Number,
      default: () => 1,
    },
    prevDisabled: {
      type: Boolean,
      default: () => false,
    },
    nextDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    disablePrev() {
      return this.prevDisabled || this.currentScreen === 1;
    },
    disableNext() {
      return this.nextDisabled || this.currentScreen === this.totalScreens;
    },
  },
};
</script>
